export const LOCAL_STORAGE_KEYS = {
  WIZARD_SURVEYS: 'hj_surveys_wizard',
};
